import React from "react";
import "./styles.css";
const ToggleButton = ({ id, isChecked, onChange }) => {
  return (
    <div className="form-check form-switch" data-widget-id={id}>
      <label className="form-check-label" for="flexSwitchCheckDefault"></label>
      <input
        className="form-check-input"
        type="checkbox"
        id="flexSwitchCheckDefault"
        checked={isChecked}
        onChange={(e) => onChange(e, id)}
      />
    </div>
  );
};

export default ToggleButton;
